export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            了解我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-6">
            关于夫妻影院
          </h2>

          <div className="text-left space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              <strong className="text-foreground-900">夫妻影院</strong>是一个专为夫妻和情侣打造的在线影视平台，致力于筛选和推荐最适合二人共同观赏的高清电影。我们深知，一部好电影不仅是消遣，更是夫妻之间情感交流的纽带。在快节奏的现代生活中，能有一段安静温馨的观影时光，是每一对伴侣都值得拥有的浪漫仪式。
            </p>
            <p>
              平台收录的每一部夫妻电影都经过编辑团队的精心筛选——从感人至深的经典爱情片到轻松愉快的浪漫喜剧，从探讨婚姻本质的家庭剧到激发共鸣的高分文艺片，覆盖了二人世界电影的各个维度。<strong className="text-foreground-900">全站免费高清在线观看不缓冲</strong>，无需注册、无广告打扰，让每一对走进夫妻影院的观众都能获得纯粹的观影体验。
            </p>
            <p>
              我们保持每日更新的节奏，持续追踪国内外最新的浪漫电影推荐，确保你总能在这里发现下一部值得与爱人共享的佳作。无论你们是刚刚步入婚姻的新人，还是相濡以沫多年的伴侣，夫妻影院都愿成为你们二人世界中最温暖的那束光影。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-10">
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
              <div className="text-3xl font-heading font-bold text-primary-500 mb-1">2024</div>
              <p className="text-xs text-foreground-500">建站年份 · 初心不改</p>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
              <div className="text-3xl font-heading font-bold text-accent-500 mb-1">50万+</div>
              <p className="text-xs text-foreground-500">月活跃观影人次</p>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
              <div className="text-3xl font-heading font-bold text-secondary-500 mb-1">99.7%</div>
              <p className="text-xs text-foreground-500">用户满意度评分</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}